import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { timeout } from 'rxjs/operators';
declare var jQuery: any;
declare var $: any;
declare let nvplay:any;
@Component({
  selector: 'app-livescore',
  templateUrl: './livescore.component.html',
  styleUrls: ['./livescore.component.scss']
})
export class LivescoreComponent implements OnInit {
loadnvplay:boolean = false;
showmatch: boolean = false;
nvplaer: any = "";
matchid: any = "";
url: string = "https://www.leicestershireccc.co.uk/assets/livematch.php?matchid=ba013d1e-dd49-41fd-8031-e9ead316a6b6";
  urlSafe: SafeResourceUrl;
iframeurl: any = "";
  constructor(
	private activatedRoute:ActivatedRoute,
	public sanitizer: DomSanitizer
  ) { 
	this.activatedRoute.params.subscribe((data)=>{
		if(data.slug){
			this.matchid = data.slug;
			
		}
		});
  }

  ngOnInit() {
	  console.log(this.matchid);
	this.activatedRoute.params.subscribe((data)=>{
		if(data.slug){
			this.url = "https://www.leicestershireccc.co.uk/assets/livematch.php?matchid="+data.slug;
			this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
		  //this.newsRequest = data.slug;
		}
		});
	//this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
	//this.matchid = "ba013d1e-dd49-41fd-8031-e9ead316a6b6";
	this.iframeurl = "https://www.leicestershireccc.co.uk/assets/livematch.php?matchid=ba013d1e-dd49-41fd-8031-e9ead316a6b6";
	setTimeout(() => {
		//this.matchid = "4334868b-d932-483f-93af-f58184048dbb";
		jQuery("#nvplay-data").html(`<nvplay id="nvwidget" 
		customer-id="2C0BC5E1-4634-457B-8996-6F4D557CD07C" 
		heading=""
		widget="match-centre" 
		poll-seconds="60"
		match-id="`+this.matchid+`">
  </nvplay>`);
  this.loadScript('https://widgets.nvplay.com/2.0/js/widgets.nvplay.js');
	}, 1000);
    jQuery(".courses-name").click(function () {
			if (jQuery(this).hasClass('active')) {
				// do nothing
			} else {
				var tabid = jQuery(this).attr('id');
				jQuery(".courses-name").removeClass('active');
				jQuery(this).addClass('active');
				jQuery(".course-main-content").removeClass('active');
				jQuery("#" + tabid + "-content").addClass("active");
			}
			return false;
		});
		jQuery("a.up-right-live-match").click(function(){
			jQuery(".live-scorecard-team-one").toggleClass("up");
			jQuery(".scorecard-titel").toggleClass("open");
			return false;
		});
		jQuery("a.up-arrow-live-match").click(function(){
			jQuery(".live-scorecard-team-two").toggleClass("up");
			jQuery(".scorecard-titel").toggleClass("down");
			return false;
		});
		jQuery("a.full-commentary-btn").click(function(){
			jQuery(".live-commentary-detail").toggleClass("full");
			return false;
		 });
		 /*setTimeout(() => {
			this.loadnvplay = true;
			this.nvplaer = `<nvplay customer-id="6cb09e4b-e702-4942-8760-659da2d1b3ff" show-competition-points="true" heading=" " widget="match-list" poll-seconds="20" source="nvplay" days="30"
			disable-advanced-filter-video-only="true" current-season="false" enable-advanced-filters="true"> </nvplay>`;
		}, 5000);*/
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

}
